import type { IMessageDto, IMessageResponse } from "./types";
import type { IPathBaseParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createPostApi } from "@api/util/createPostApi";
import { markAsRead } from "@api/conversations/messages/markAsRead/api";
import type { IChannelsGetAllResponse } from "@api/channels/types";
import type { IUsersResponse } from "@api/users/types";

const getAllApis = createGetAllApi<
  IApiResponse<
    IPagination<
      IMessageResponse,
      { other_user: IUsersResponse; channel: IChannelsGetAllResponse }
    >
  >,
  IPathBaseParam,
  IPaginationParams
>("conversations.messages");
const postApis = createPostApi<
  IApiResponse<IMessageResponse>,
  IPathBaseParam,
  IMessageDto
>("conversations.messages");

export const messages = {
  ...getAllApis,
  ...postApis,
  markAsRead,
};
